<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
	
    <app-panel-summary label="Status" :tag="$constants.membership.subscription.statusName[item.status]" :status="$constants.membership.subscription.statusTheme[item.status]" :theme="$constants.membership.subscription.statusTheme[item.status]" />
		
	<app-panel-summary label="Ref." :value="item.reference" />
	
    <app-panel-summary v-if="item.type" label="Type" :value="item.type.name" />
    
    <app-panel-summary v-if="item.plan" label="Plan" :value="item.plan.name" />
	
</app-panel-content>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

</style>
